module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }), _c('a', {
    attrs: {
      "id": "pageii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA ON THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINK:")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW THE")]), _c('br'), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLITICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRUGGLE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VER THE")]), _c('br'), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR OF")]), _vm._v(" 1812 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LMOST")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTROYED THE")]), _c('br'), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNG")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPUBLIC")])]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UEL")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R.")])]), _vm._v(" "), _c('p', {
    staticClass: "titlelogo"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  }), _vm._v(" ST. MARTIN’S GRIFFIN "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo1.jpg"
    }
  }), _vm._v(" NEW YORK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e9b09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 57
// module chunks = 0